// config/config.js
import { HEALTH_SCORES, EMPLOYEE_RANGES } from './constants';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: process.env.NODE_ENV === 'development' ? 'Info' : 'Error',
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (process.env.NODE_ENV === 'development') {
          switch (level) {
            case 0: // Error
              console.error(message);
              break;
            case 1: // Warning
              console.warn(message);
              break;
            case 2: // Info
              console.info(message);
              break;
            default:
              console.log(message);
              break;
          }
        }
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [`https://${process.env.REACT_APP_DYNAMICS_ORG}/.default`],
};

export const dynamicsBaseUrl = `https://${process.env.REACT_APP_DYNAMICS_ORG}/api/data/v9.2`;

export const dynamicsWebUrl = `https://${process.env.REACT_APP_DYNAMICS_ORG}`;

// Poids pour le scoring (configurable localement)
export const scoringWeights = {
  industrycode: 0.4,
  _dimsi_countryid_value: 0.3,
  _dimsi_zoneid_value: 0.2,
  dimsi_nbofemployees: 0.1,
};

// Health Score boost mapping (ajout au score, pas un critère strict)
// Codes Dynamics pour Health Score et leurs bonus respectifs
export const healthScoreBoosts = {
  [HEALTH_SCORES.GREEN]: 0,  // Green (Sain)
  [HEALTH_SCORES.YELLOW]: -0.05,  // Yellow (Alerte)
  [HEALTH_SCORES.RED]: -0.10,  // Red (Danger)
  [HEALTH_SCORES.BLUE]: -0.01,  // Blue (Neutre)
  [HEALTH_SCORES.BLACK]: -0.20, // Black (Critique)
  [HEALTH_SCORES.PURPLE]: 0.0,  // Purple (Autre)
  // Fallback: null ou undefined → pas de boost
  null: 0.0,
  undefined: 0.0,
};

// Health Score priority for sorting (lower = better, shown first)
export const healthScorePriority = {
  [HEALTH_SCORES.GREEN]: 1,  // Green (Sain)
  [HEALTH_SCORES.YELLOW]: 2,  // Yellow (Alerte)
  [HEALTH_SCORES.BLUE]: 3,  // Blue (Neutre)
  [HEALTH_SCORES.PURPLE]: 4,  // Purple (Autre)
  [HEALTH_SCORES.RED]: 5,  // Red (Danger)
  [HEALTH_SCORES.BLACK]: 6,  // Black (Critique)
};
export const HEALTH_SCORE_PRIORITY_DEFAULT = 99; // No health score → last

// Ranges pour dimsi_nbofemployees
export const employeeRanges = [
  { value: EMPLOYEE_RANGES.R_1_49, label: '1-49' },
  { value: EMPLOYEE_RANGES.R_50_299, label: '50-299' },
  { value: EMPLOYEE_RANGES.R_300_499, label: '300-499' },
  { value: EMPLOYEE_RANGES.R_500_999, label: '500-999' },
  { value: EMPLOYEE_RANGES.R_1000_4999, label: '1000-4999' },
  { value: EMPLOYEE_RANGES.R_5000_PLUS, label: '5000+' },
];

// Navigation properties on account to expand (add navigation logical names here)
export const accountNavigationExpands = [
  // Example: 'dimsi_PartnerId' (lookup navigation property found in metadata)
  'dimsi_PartnerId'
];